import React, { memo, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { askUserForPaymentFiles } from 'reactApp/modules/uploadList/oldUploadListBridge';
import { IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from './PopupWarnings.css';

interface IProps {
    file: IInputFile;
    isStrangerOwner: boolean;
}

const OverQuota = ({ file, isStrangerOwner }: IProps) => {
    const handleOverQuota = useCallback(() => {
        askUserForPaymentFiles('payment');
    }, []);

    const handleOverQuotaSkip = useCallback(() => {
        askUserForPaymentFiles('skip');
    }, []);

    const renderHeader = useCallback(
        () => (
            <div>
                Невозможно загрузить файл <NameComponent name={file.name} truncate />
            </div>
        ),
        [file.name]
    );

    const renderContent = useCallback(() => {
        const content = isStrangerOwner
            ? 'Загрузка невозможна. У владельца этой папки недостаточно места в Облаке для ваших файлов'
            : 'Ваше Облако переполнено. Удалите лишнее или увеличьте его размер.';

        return (
            <div className={styles.content}>
                <div>{content}</div>
            </div>
        );
    }, []);

    return (
        <BaseConfirmDialog
            dataQAId="overquota-dialog"
            renderHeader={renderHeader}
            successButtonText="Посмотреть тарифы"
            cancelButtonText="Пропустить файл"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            onSuccess={handleOverQuota}
            onClose={handleOverQuotaSkip}
            renderContent={renderContent}
            className={styles.root}
        />
    );
};

export const OverQuotaComponent = memo(OverQuota);
